
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommRepairItemsGrid extends Serenity.EntityGrid<ECommRepairItemsRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommRepairItems'; }
        protected getDialogType() { return ECommRepairItemsDialog; }
        protected getIdProperty() { return ECommRepairItemsRow.idProperty; }
        protected getInsertPermission() { return ECommRepairItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommRepairItemsRow.localTextPrefix; }
        protected getService() { return ECommRepairItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }
        
    }
}